import { CmsApi } from './cmsApi';

const cmsApi = new CmsApi();

export { cmsApi };
